import { useMemo } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Plot3d from "../../shared/charts/Plot3d";
import { MeasurementType } from "../../shared/enums/Result";
import { UTP2Data, UTP2Events } from "../../shared/interfaces/UTP2";
import { buildPRPSPlots } from "./PRPSFunctions";

interface Props {
  loading?: boolean;
  data?: UTP2Events | UTP2Data;
  measurementType: MeasurementType;
  phaseShift?: number;
  riseTime?: [number, number];
  pulseWidth?: [number, number];
}

export function PRPSChart(props: Props) {
  const phasePlotSeries = useMemo(() => {
    if (props.data && "headings" in props.data) {
      if (props.data.headings == null) {
        return undefined;
      }
      return buildPRPSPlots(props.data, props.measurementType, props.riseTime, props.pulseWidth, props.phaseShift);
    } else return undefined;
  }, [props.data, props.measurementType, props.phaseShift, props.riseTime, props.pulseWidth]);

  if (props.loading) {
    return (
      <div className="d-flex justify-content-center">
        <CircularProgress size={65} />
      </div>
    );
  } else if (phasePlotSeries) {
    return <Plot3d series={phasePlotSeries} />;
  } else {
    return null;
  }
}
